module.exports = __webpack_public_path__ + "static/img/banner-bienvenidos-500x750.21a4199.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-bienvenidos-500x750.jpg
// module id = gcg1
// module chunks = 47